import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Layout } from "../Components/allcomponents";

const EditCount = () => {
  const [count, setCount] = useState(0);
  const params = useParams();
  const { id } = params;
  const navigate = useNavigate();
  const handleData = async () => {
    await axios
      .post("https://erpapi.eshiksa.net/formBuilderFieldData.php", {
        formUrlToken: id,
        dbname: "erp_eshiksa",
        tag: "fieldDataBuilder",
      })
      .then((res) => {
        console.log(res.data);
        setCount(res.data.count);
      })
      .catch((err) => {
        // setLoading(false);
        console.error(err);
      });
  };

  useEffect(() => {
    handleData(); // eslint-disable-next-line
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    //comment
    await axios
      .post("https://erpapi.eshiksa.net/updateFormBuilderData.php", {
        formUrlToken: id,
        Branch_id: localStorage.getItem("Branch_id"),
        dbname: "erp_eshiksa",
        tag: "updateCount",
        count: count,
      })
      .then((res) => {
        console.log(res.data);
        navigate("/Formlist");
      })
      .catch((err) => {
        // setLoading(false);
        console.error(err);
      });
  };

  return (
    <Layout>
      <div className="container my-2">
        <h5>UPDATE COUNT</h5>
        <form onSubmit={(e) => handleSubmit(e)} className="d-flex">
          <input
            className="form-control w-50"
            type="number"
            name="no_of_successfull_payment"
            value={count}
            onChange={(e) => {
              setCount(e.target.value);
            }}
          />
          <input
            className="btn btn-primary btn-sm mx-2"
            value="Update Count"
            type="submit"
          />
        </form>
      </div>
    </Layout>
  );
};

export default EditCount;
